$ojp-listbox-transition-time: 0.2s;

:host {
  --list-height: 0px;

  display: inline-block;
  cursor: pointer;
  position: relative;

  .ojp-listbox-button {
    // forwarding all the properties to the button here
    // because the button is the main visible element of the listbox.
    // We can avoid the need to create CSS variables if we
    // let the user just style the component as they want.
    all: inherit;
    border: none;
    cursor: pointer;
  }

  ::slotted(ul) {
    height: 0;
    left: 0;
    list-style: none;
    margin: 0;
    overflow: hidden scroll;
    padding: 0;
    position: absolute;
    top: calc(100% + 11px);
    transition: height ease-in-out $ojp-listbox-transition-time, visibility linear 0s $ojp-listbox-transition-time;
    visibility: hidden;
    width: 100%;
    z-index: 999;
  }

  ::slotted(ul > li) {
    cursor: pointer;
    list-style: none;
    padding: 0;

    &[aria-selected="true"] {
      outline: 2px solid blue;
    }
  }

  ::slotted(ul.expanded) {
    height: var(--list-height);
    transition: height ease-in-out $ojp-listbox-transition-time;
    visibility: visible;
  }

}
